import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/i18n";

export const PolicyDialog = ({ open, onOpenChange, type }) => {
  const { t } = useLang();
  const p = t.policies[type] || t.policies.privacy;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className="max-h-[82vh] max-w-lg overflow-y-auto border-line bg-ivory text-ink"
        data-testid={`policy-dialog-${type}`}
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-medium text-ink">{p.title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm leading-relaxed text-[#4A4F4C]">
          {p.body.map((par, i) => (
            <p key={i}>{par}</p>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
